/* eslint-disable no-unused-vars */
import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-left">
                    <span className="footer-logo">marque<span>index</span></span>
                    <p className="footer-tagline">Men's Clothing Brand Discovery</p>
                </div>
                <div className="footer-links">
                    <Link to="/about">About</Link>
                    <Link to="/legal">Privacy & Terms</Link>
                    <a href="mailto:hello@marqueindex.com">Contact</a>
                </div>
                <p className="footer-disclaimer">
                    All brand names, logos, and product images are trademarks of their respective owners. 
                    Marque Index is not affiliated with or endorsed by any listed brand.
                </p>
            </div>
        </footer>
    )
}

export default Footer
